<script lang="ts" setup>
defineProps<{
  radius: Number
  hideLabel?: Boolean
  inline?: Boolean
}>()
</script>

<template>
  <div :class="`${inline ? 'inline-flex' : 'flex'} items-center gap-1.5`">
    <svg
      v-if="radius == 34"
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="10"
      fill="none"
      viewBox="0 0 9 10"
    >
      <path stroke="#ACB1B5" d="M9 1H8a7 7 0 0 0-7 7v2" />
      <circle cx="8" cy="9" r="1" fill="#D9D9D9" />
    </svg>
    <svg
      v-else-if="radius == 24"
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="10"
      fill="none"
      viewBox="0 0 9 10"
    >
      <path stroke="#ACB1B5" d="M9 1H6a5 5 0 0 0-5 5v4" />
      <circle cx="8" cy="9" r="1" fill="#D9D9D9" />
    </svg>
    <svg
      v-else-if="radius == 22"
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="10"
      fill="none"
      viewBox="0 0 9 10"
    >
      <path stroke="#ACB1B5" d="M9 1H5a4 4 0 0 0-4 4v5" />
      <circle cx="8" cy="9" r="1" fill="#D9D9D9" />
    </svg>
    <svg
      v-else-if="radius == 15"
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="10"
      fill="none"
      viewBox="0 0 9 10"
    >
      <path stroke="#ACB1B5" d="M9 1H4a3 3 0 0 0-3 3v6" />
      <circle cx="8" cy="9" r="1" fill="#D9D9D9" />
    </svg>
    <span v-if="!hideLabel">{{'<'}}{{ radius }} m</span>
  </div>
</template>
